import React, { useState } from "react";
import Home from "../Home/Home";
import { Header } from "../common/Header";
import HotelPageCard from "./HotelPageCard";
import HotelPageAccordion from "./HotelPageAccordion";
import { getDirectionUrl, openExtUrl, sendAnalyticsToGA } from "../../utils/commanFunctions";
import Spinner from "../spinner/Spinner";
import { trackCTA, trackExit } from "../../utils/FunctionsForGa";
import configs from "../../contentConfig";

const hotelPageConfig = configs?.hotelPage || {};

const ICONS = {
  faq: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 22V15.43M12 11H12.01M12 7H12.01M14 15.43V22M15 16C14.1345 15.3509 13.0819 15 12 15C10.9181 15 9.86548 15.3509 9 16M16 11H16.01M16 7H16.01M8 11H8.01M8 7H8.01M6 2H18C19.1046 2 20 2.89543 20 4V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2Z"
        stroke="#1A1A1A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  wifi: (
    <svg
      width="22"
      height="17"
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 15.9997H11.01M1 4.81966C3.75011 2.35989 7.31034 1 11 1C14.6897 1 18.2499 2.35989 21 4.81966M4 8.85866C5.86929 7.02639 8.38247 6.00009 11 6.00009C13.6175 6.00009 16.1307 7.02639 18 8.85866M7.5 12.4287C8.43464 11.5125 9.69124 10.9994 11 10.9994C12.3088 10.9994 13.5654 11.5125 14.5 12.4287"
        stroke="#1A1A1A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  directions: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 11L17 6M17 6L12 1M17 6H5C3.93913 6 2.92172 6.42143 2.17157 7.17157C1.42143 7.92172 1 8.93913 1 10V17"
        stroke="#1A1A1A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

const Hotel = () => {
  const [showIframe, setShowIframe] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");
  const [loadingIframe, setLoadingIframe] = useState(true);

  const hotelAddress = JSON.parse(localStorage.getItem("hotelInfo"));

  const runCardAction = (action) => {
    if (!action) return;
    if (action.trackAction) trackCTA({ action: action.trackAction });
    switch (action.type) {
      case "iframe":
        if (!/^https?:\/\//i.test(action.url || "")) return;
        setIframeUrl(action.url);
        setShowIframe(true);
        setLoadingIframe(true);
        break;
      case "directions":
        openExtUrl(getDirectionUrl(hotelAddress?.name), "_system");
        break;
      case "external":
        openExtUrl(action.url, "_blank");
        break;
      default:
        break;
    }
  };

  const hotelPageCardsData = (hotelPageConfig.cards || []).map((c) => ({
    ...c,
    icon: ICONS[c.icon] || null,
  }));

  const hotelAccordionData = hotelPageConfig.accordion || [];
  return (
    <>
      {showIframe ? (
        <div className="absolute w-full h-[100vh] z-[100] bg-white flex flex-col">
          <div className="header-iframe-bar h-[44px] w-full md:w-[100vw]  flex items-center pl-3 z-[101]  mx-auto text-white">
            <div
              onClick={() => {
                const selectedTab = localStorage.getItem("selectedTab");
                
                trackExit({tab: selectedTab})
                setShowIframe(false);
              }}
              className=" w-fit font-normal tracking-[0] leading-[normal] whitespace-nowrap flex items-center gap-[2px] cursor-pointer"
            >
              <svg
                className="cursor-pointer"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 18L9 12L15 6"
                  stroke="#F8F8F8"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div className="header-back-text cursor-pointer text-[#F8F8F8] text-[14px] leading-[20px] font-light mt-[2px]">
                Back
              </div>
            </div>
          </div>
          {loadingIframe && (
            <div className="w-full flex justify-center items-center py-10 min-h-[50vh]">
              <Spinner />
            </div>
          )}
          <iframe
            className="z-0"
            src={iframeUrl}
            width={"100%"}
            title={hotelPageConfig.iframeTitle || "FAQs"}
            onLoad={() => setLoadingIframe(false)}
            style={{
              maxWidth: "1000px",
              marginLeft: "auto",
              marginRight: "auto",
              height: "calc(100% - 44px)",
              display: loadingIframe ? "none" : "block",
            }}
          />
        </div>
      ) : (
        <Home showBottomNav={true} nav={"Hotel"}>
          <Header
            showFilter={false}
            showSearch={false}
          />
          <div className="hotel-page-content w-full max-w-[1000px] md:mx-auto pt-11 pb-[140px] gap-8 flex flex-col">
            <div className="hotel-page-images flex flex-col w-full">
              <div className="hotel-page-image w-full h-[272px]"></div>
              {hotelPageConfig.secondImage?.visible && (
                <div className="hotel-page-image-second"></div>
              )}
            </div>
            <div className="hotel-page-heading w-full text-4xl text-center">
              {hotelPageConfig.heading || "Hotel"}
            </div>
            <div className="hotel-page-cards flex h-[88px] w-full px-4 gap-2  overflow-x-scroll md:justify-center">
              {hotelPageCardsData.map((card, index) => (
                <HotelPageCard
                  key={index}
                  card={card}
                  onCardClick={() => runCardAction(card.action)}
                />
              ))}
            </div>
            <div className="hotel-page-accordion">
              {hotelAccordionData.map((data, index) => (
                <HotelPageAccordion data={data} key={index} />
              ))}
            </div>
          </div>
        </Home>
      )}
    </>
  );
};

export default Hotel;
